import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createPaymentType,
  deletePaymentType,
  getPaymentTypes,
  updatePaymentType,
} from "data/server_apis/paymentService";

const paymentTypeAdapter = createEntityAdapter({
  selectId: (paymentType) => paymentType.id,
});

export const getPaymentTypesThunk = createAsyncThunk(
  "paymentTypes/get",
  async (_, { rejectWithValue }) => {
    try {
      return (await getPaymentTypes()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createPaymentTypeThunk = createAsyncThunk(
  "paymentTypes/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createPaymentType(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updatePaymentTypeThunk = createAsyncThunk(
  "paymentType/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updatePaymentType(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deletePaymentTypeThunk = createAsyncThunk(
  "paymentType/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deletePaymentType(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);



const paymentTypesSlice = createSlice({
  name: "paymentType",
  initialState: paymentTypeAdapter.getInitialState({
    status: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentTypesThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getPaymentTypesThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getPaymentTypesThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        paymentTypeAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(createPaymentTypeThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createPaymentTypeThunk.rejected, (state, action) => {
        state.status = {
          error: "create",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(createPaymentTypeThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        paymentTypeAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updatePaymentTypeThunk.pending, (state, action) => {
        state.status = { loading: "update", id: action.meta.arg.id };
      })
      .addCase(updatePaymentTypeThunk.rejected, (state, action) => {
        state.status = {
          error: "update",
          errorMessage: action.payload?.message,
          id: action.meta.arg.id,
        };
      })
      .addCase(updatePaymentTypeThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        paymentTypeAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deletePaymentTypeThunk.pending, (state, action) => {
        state.status = { loading: "delete", id: action.meta.arg.id };
      })
      .addCase(deletePaymentTypeThunk.rejected, (state, action) => {
        state.status = {
          id: action.meta.arg.id,
          error: "delete",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(deletePaymentTypeThunk.fulfilled, (state, action) => {
        state.status = { success: "delete", id: action.meta.arg.id };
        paymentTypeAdapter.removeOne(state, action.meta.arg);
      });
  },
});
export const paymentTypeSelector = paymentTypeAdapter.getSelectors(
  (state) => state.paymentType
);
export const {} = paymentTypesSlice.actions;

export default paymentTypesSlice.reducer;
